import React from 'react';

import { useIntl } from 'react-intl';
import { useParams } from 'react-router-dom';

import { useCreatePricingPlanPeriodAdjustment } from 'src/features/pricingPlan/api/adjustments/useCreatePricingPlanPeriodAdjustment';
import { LIST_PRICING_PLAN_PERIOD_ADJUSTMENTS_RESOURCE } from 'src/features/pricingPlan/api/adjustments/useListPricingPlanPeriodAdjustments';
import AdjustmentFormModal from 'src/features/pricingPlan/components/form/adjustments/AdjustmentFormModal';
import { pricingPlanMessages } from 'src/features/pricingPlan/utils/messages';
import { toast } from 'src/hooks/UseToast';
import { queryClient } from 'src/lib/react-query';
import { useParking } from 'src/providers/ParkingProvider';
import { DataTableNewEntryProps } from 'src/registry/components/table/types';
import { generalMessages } from 'src/registry/utils/messages';
import { ICON_MAP } from 'src/utils/constants';

interface AdjustmentsFormModalProps<TData> extends DataTableNewEntryProps<TData> {
    children?: React.ReactNode;
}

function CreateAdjustmentFormModal<TData>({ className, semantics }: AdjustmentsFormModalProps<TData>) {
    const { formatMessage } = useIntl();
    const { planId = '' } = useParams();
    const { parkingId } = useParking();

    const { mutate, isPending } = useCreatePricingPlanPeriodAdjustment({
        onSuccess: () => {
            void queryClient.invalidateQueries({ queryKey: [LIST_PRICING_PLAN_PERIOD_ADJUSTMENTS_RESOURCE] });
            toast({
                title: formatMessage(pricingPlanMessages.createAdjustmentSuccess),
                description: formatMessage(pricingPlanMessages.createAdjustmentSuccessDescription),
            });
        },
    });

    return (
        <AdjustmentFormModal
            className={className}
            mutate={(values, onSuccess, onError) => mutate({ planId, parkingId, ...values }, { onSuccess, onError })}
            title={formatMessage(generalMessages.createEntry, { entry: semantics?.entryName?.toLowerCase() })}
            icon={ICON_MAP.ADD}
            isPending={isPending}
            subtitle={formatMessage(pricingPlanMessages.addAdjustmentSubtitle)}
        />
    );
}

export default CreateAdjustmentFormModal;
